import { Box, Button, FormControl, IconButton, InputLabel, MenuItem, Select, TextField } from '@mui/material';

import React, { useEffect, useState } from 'react';
import { MdDelete } from 'react-icons/md';
import { useSnackbar } from 'notistack';
import { fetchRuleSelectorMetricList } from "../api's/DataProcessorApi";

const CustomRuleSelector = ({
  uniqueId,
  columnName,
  selectedColumnName,
  handleUniqueId,
  handleAdd,
  handleDelete,
  configData,
  handleChange,
  disableForm,
  predefinedRules,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const criteria = [
    {
      label: 'String',
      value: 'string',
    },
    {
      label: 'Number',
      value: 'number',
    },
    {
      label: 'Boolean',
      value: 'boolean',
    },
  ];

  const [metricList, setMetricList] = useState([]);

  const getRuleSelectorMetricList = async () => {
    try {
      const response = await fetchRuleSelectorMetricList();
      if (response.status === 200) {
        setMetricList(response.data);
      }
    } catch (error) {
      enqueueSnackbar('Error while fetching Metric List!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
  };

  useEffect(() => {
    getRuleSelectorMetricList();
  }, []);

  return (
    <>
      <Box sx={{ marginTop: '16px' }}>
        {configData?.map((data, i) => (
          <Box
            component="form"
            key={i}
            sx={{
              '& .MuiTextField-root': { m: 1, width: '35ch' },
              marginTop: '12px',
            }}
            noValidate
            autoComplete="off"
          >
            <FormControl style={{ width: '20%' }} size="small">
              <InputLabel>Column Name</InputLabel>
              <Select
                id="demo-simple-select-helper"
                name="field_name"
                size="small"
                label="Column Name"
                value={data.field_name}
                onChange={(e) => handleChange(e, i)}
                key={data.id}
                disabled={disableForm}
                sx={{ background: '#ffffff' }}
              >
                {columnName.field_name
                  ? columnName
                      ?.sort((a, b) => a.field_name?.localeCompare(b.field_name))
                      ?.map((item) => (
                        <MenuItem key={item.id} value={item.field_name}>
                          {item.field_name}
                        </MenuItem>
                      ))
                  : columnName
                      ?.sort((a, b) => a.header?.localeCompare(b.header))
                      ?.map((item) => (
                        <MenuItem key={item.id} value={item.header}>
                          {item.header}
                        </MenuItem>
                      ))}
              </Select>
            </FormControl>
            <FormControl style={{ width: '20%', marginLeft: '2%' }} size="small">
              <InputLabel>Data type</InputLabel>
              <Select
                id="demo-simple-select-helper"
                name="dataType"
                size="small"
                label="Data type"
                // value={data.dataType}
                value="string"
                onChange={(e) => handleChange(e, i)}
                key={data.id}
                disabled
                sx={{ background: '#ffffff' }}
              >
                {criteria.map((item) => (
                  <MenuItem key={item.label} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              style={{ width: '20%', margin: '0px 0% 0px 2%' }}
              label="Statement"
              id="outlined-size-small"
              margin="none"
              name="statement"
              key={data.id}
              size="small"
              disabled={disableForm}
              onChange={(e) => handleChange(e, i)}
              value={data.statement}
            />

            {/* <TextField
              style={{ width: '20%', margin: '0px 0% 0px 2%' }}
              label="Metric"
              id="outlined-size-small"
              margin="none"
              name="metric"
              key={data.id}
              size="small"
              disabled={disableForm}
              onChange={(e) => handleChange(e, i)}
              value={data.metric}
            /> */}
            {predefinedRules && (
              <FormControl style={{ width: '20%', marginLeft: '2%' }} size="small">
                <InputLabel>Metric</InputLabel>
                <Select
                  id="demo-simple-select-helper"
                  name="metric"
                  size="small"
                  label="Metric"
                  value={data.metric}
                  onChange={(e) => handleChange(e, i)}
                  key={data.id}
                  disabled={disableForm}
                  sx={{ background: '#ffffff' }}
                >
                  {metricList
                    ?.sort((a, b) => a.metric_type?.localeCompare(b.metric_type))
                    ?.map((item) => (
                      <MenuItem key={item.rm_id} value={item.metric_type}>
                        {item.metric_type}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            )}

            <IconButton aria-label="expand row" size="medium" disabled={disableForm} onClick={() => handleDelete(data)}>
              <MdDelete />
            </IconButton>
          </Box>
        ))}
      </Box>

      <Button
        variant="contained"
        sx={{
          display: 'flex',
          marginTop: '8px',
          alignContent: 'flex-start',
          backgroundColor: '#00043C',
          '&:hover': { backgroundColor: '#00043C' },
        }}
        onClick={handleAdd}
        disabled={disableForm}
      >
        Add Custom Rules
      </Button>
    </>
  );
};

export default CustomRuleSelector;
